var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserSquareBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2333 36.0345C28.7666 36.4679 27.0333 36.6679 24.9999 36.6679H14.9999C12.9666 36.6679 11.2333 36.4679 9.7666 36.0345C10.1333 31.7012 14.5833 28.2845 19.9999 28.2845C25.4166 28.2845 29.8666 31.7012 30.2333 36.0345Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0002 3.33333H15.0002C6.66683 3.33333 3.3335 6.66666 3.3335 15V25C3.3335 31.3 5.2335 34.75 9.76683 36.0333C10.1335 31.7 14.5835 28.2833 20.0002 28.2833C25.4168 28.2833 29.8668 31.7 30.2335 36.0333C34.7668 34.75 36.6668 31.3 36.6668 25V15C36.6668 6.66666 33.3335 3.33333 25.0002 3.33333ZM20.0002 23.6166C16.7002 23.6166 14.0335 20.9334 14.0335 17.6334C14.0335 14.3334 16.7002 11.6667 20.0002 11.6667C23.3002 11.6667 25.9668 14.3334 25.9668 17.6334C25.9668 20.9334 23.3002 23.6166 20.0002 23.6166Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9665 17.6334C25.9665 20.9334 23.2999 23.6166 19.9999 23.6166C16.6999 23.6166 14.0332 20.9334 14.0332 17.6334C14.0332 14.3334 16.6999 11.6667 19.9999 11.6667C23.2999 11.6667 25.9665 14.3334 25.9665 17.6334Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSquareBlack);
export default __webpack_public_path__ + "static/media/user-square-black.dc92537bf0ff18a27f5ecc1553ff7156.svg";
export { ForwardRef as ReactComponent };